import { render, staticRenderFns } from "./First.vue?vue&type=template&id=a3537aac&scoped=true&lang=pug"
import script from "./First.vue?vue&type=script&lang=js"
export * from "./First.vue?vue&type=script&lang=js"
import style0 from "./First.vue?vue&type=style&index=0&id=a3537aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3537aac",
  null
  
)

export default component.exports